import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header';
import Footer from './components/FooterItem';
import Home from './pages/Home';
import About from './pages/About';
import Archives from './pages/Archive';
import PostDetail from './pages/PostDetail';
import WritePost from './pages/WritePost';
import Auth from './pages/Auth'; // 个人信息页面（重用Auth文件）
import NotFound from './pages/NotFound';
import Contact from './pages/Contact'; // 新增导入语句
import './App.css';

const { Content } = Layout;

function App() {
  return (
    <Router>
      <Layout className="layout">
        <Header />
        <Content className="content">
          <div className="site-layout-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/archives" element={<Archives />} />
              <Route path="/write-post" element={<WritePost />} />
              <Route path="/edit/:id" element={<WritePost />} />
              <Route path="/my" element={<Auth />} />
              <Route path="/post/:id" element={<PostDetail />} />
              <Route path="/contact" element={<Contact />} /> {/* 新增路由配置 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Content>
        <Footer />
      </Layout>
    </Router>
  );
}

export default App;